export const selectCars = state => state.cars.cars;
export const selectSelectedCar = state => state.cars.selectedCar;
export const selectFavorites = state => state.cars.favorites;
export const selectIsLoading = state => state.cars.isLoading;
export const selectError = state => state.cars.error; 